export default "__VITE_ASSET__5bfeae82__"